import { render } from "./PaymentConfiguration.vue?vue&type=template&id=0236f860"
import script from "./PaymentConfiguration.vue?vue&type=script&lang=js"
export * from "./PaymentConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__